/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {SubscriptionDtoModel} from "@well/domain";
import {Observable} from "rxjs";
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';
import { InvalidateLegalEntityInfoDTO } from '@well/platform-administration/payments/domain';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionResourceService extends AbstractResourceService<any,
  SubscriptionDtoModel,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('subscriptionUrl'),
      undefined,
      SubscriptionDtoModel
    );
  }

  getLegalEntitiesForSubscriptionType(subscriptionTypeUuid: string): Observable<JsonApiResource<LegalEntityModel[], JsonApiListResourceMetadataBase>> {

      return <Observable<JsonApiResource<LegalEntityModel[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/legalEntities/${subscriptionTypeUuid}`,{headers: this.headers});

  }

  invalidateSubscription(subscriptionUuid: string, invalidateLegalEntityInfoDTO: InvalidateLegalEntityInfoDTO): Observable<any> {
    return this.httpClient?.post(`${this.url}/invalidate/${subscriptionUuid}`, invalidateLegalEntityInfoDTO, {headers: this.headers});
  }

  reactivateSubscription(subscriptionUuid: string): Observable<any> {
    return this.httpClient?.post(`${this.url}/reactivate/${subscriptionUuid}`, {headers: this.headers});
  }
}
